const ArrowIcon = ({ variant = "normal" }: { variant?: "normal" | "thin" }) => {
  return variant === "normal" ? (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="17"
      viewBox="0 0 19 17"
      fill="none"
    >
      <path
        d="M9.70357 0.51666C10.3798 1.2024 10.3845 2.3123 9.69889 3.0004L5.96207 6.74486L17.2568 6.74486C18.2185 6.74486 19 7.53192 19 8.50044C19 9.46896 18.2185 10.2537 17.2568 10.2537L5.96207 10.2537L9.69889 14.0028C10.3845 14.6862 10.3798 15.7985 9.70357 16.4842C9.02734 17.17 7.92291 17.1723 7.23966 16.4889L0.512438 9.74467C0.510098 9.74231 0.510098 9.74231 0.510098 9.74231C0.350985 9.58207 0.22229 9.38884 0.135714 9.17675C0.0467977 8.96467 -3.6133e-07 8.73373 -3.71528e-07 8.50044C-3.81828e-07 8.26479 0.0467976 8.03386 0.135714 7.82177C0.22229 7.61205 0.350985 7.42117 0.507758 7.26093C0.510098 7.25857 0.510098 7.25622 0.512438 7.25622L7.23965 0.511947C7.92291 -0.171433 9.02734 -0.171433 9.70357 0.51666Z"
        fill="currentColor"
      />
    </svg>
  ) : (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="8"
      viewBox="0 0 12 8"
      fill="none"
    >
      <path
        d="M11.3536 4.35355C11.5488 4.15829 11.5488 3.84171 11.3536 3.64645L8.17157 0.464465C7.97631 0.269203 7.65973 0.269203 7.46447 0.464465C7.2692 0.659728 7.2692 0.97631 7.46447 1.17157L10.2929 4L7.46447 6.82843C7.2692 7.02369 7.2692 7.34027 7.46447 7.53553C7.65973 7.7308 7.97631 7.7308 8.17157 7.53553L11.3536 4.35355ZM4.37114e-08 4.5L11 4.5L11 3.5L-4.37114e-08 3.5L4.37114e-08 4.5Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default ArrowIcon;
